var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "mail-integration-detail" } }, [
    _c(
      "div",
      { staticClass: "route-page-content" },
      [
        _c("SidebarChild", {
          attrs: {
            items: _vm.sidebarItems,
            selectedItem: _vm.currentTab,
            focusActive: true,
          },
          on: { selected: _vm.handleSidebarSelection },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "page-content-wrapper" }, [
          _c("div", { staticClass: "toolbar" }, [
            _c(
              "div",
              { staticClass: "left-toolbar-content" },
              [
                _c(
                  "IconButton",
                  {
                    attrs: {
                      "on-click": function () {
                        return _vm.$router.push("/integrations/mail")
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" chevron_left "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "icon-container" }, [
                  _c("img", { attrs: { src: _vm.logoUrl } }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "name" }, [
                  _vm._v(
                    _vm._s(_vm.$t("mail.mailDetail")) +
                      ": " +
                      _vm._s(_vm.selectedMail ? _vm.selectedMail.mail : "")
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right-toolbar-content" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteMailAddress()
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("chatbotv2.delete")) +
                        "\n                    "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-content" },
            [
              _vm.currentTab === "integration" ? _c("Integration") : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "sender" ? _c("SenderMailAddress") : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "signature" ? _c("Signature") : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "inbox"
                ? _c("Mails", { attrs: { selectedMail: _vm.selectedMail } })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "medias" ? _c("Medias") : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "visibility"
                ? _c("VisibilityChanger", { attrs: { alertMessage: false } })
                : _vm._e(),
              _vm._v(" "),
              _vm.currentTab === "contacts" ? _c("MailVisitors") : _vm._e(),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }